'use client';

import { useLocale } from 'next-intl';
import { Configure } from 'react-instantsearch';

import { InstantSearchProvider, getDefaultFilters } from '@commons/components/Search';
import SearchInput from '@commons/components/Search/Input';
import SearchStats from '@commons/components/Search/Stats';
import Flex from '@commons/containers/Flex';
import { ALGOLIA_INDEX } from '@commons/utils/constants';

import { ATTRIBUTES_TO_RETRIEVE } from '@/components/Search/Hit';
import SearchLayout from '@/components/Search/Layout';

/**
 * Global search variant of the AlgoliaSearchBlock component.
 *
 * @see https://www.algolia.com/doc/api-reference/widgets/configure/react/
 */

const GlobalSearch = () => {
  const locale = useLocale();

  const filters = getDefaultFilters(locale);

  const renderedTopBar = (
    <Flex
      gap="sm"
      width={12}
      align={{ md: 'center' }}
      justify="space-between"
      direction={{ xs: 'column', md: 'row' }}
    >
      <Flex.Item width={{ xs: 12, md: 6 }}>
        <SearchInput />
      </Flex.Item>
      <SearchStats />
    </Flex>
  );

  return (
    <InstantSearchProvider
      indexName={ALGOLIA_INDEX}
      enableEmptySearch
      initialSearchUrl="/api/search/initial/global"
    >
      <Configure filters={filters} hitsPerPage={12} attributesToRetrieve={ATTRIBUTES_TO_RETRIEVE} />
      <SearchLayout topChildren={renderedTopBar} />
    </InstantSearchProvider>
  );
};

export default GlobalSearch;
